import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesASAP from "./stylesASAP"
import DatePicker from "react-datepicker";
import "rc-time-picker/assets/index.css";
import { FaUser, FaPhoneAlt, FaMobileAlt, FaBirthdayCake } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import Loading from "../Loading"
import ASAPAuthenticate from "../Functions/ASAPAuthenticate"
import stylesMed from "../MedRep/stylesMed"

export default class ClientAdd extends React.Component {

    constructor() {
        super();
        this.state =
        {
            countries: [], groupT: [], currencyT: [], titleT: [], createCount: 0, createclients: 0, showRequiredAlert: false, alertString: "", typeT: [],
            disableSave: false, name: "", specialties: [], availability: "", specialty: "", type: "", potential: [], brick: "", address: "", phone: "",
            mobile: "", email: "", birthday: "", items: "", deal: "", alertdanger: "", alertsuccess: "", showalert: false, days: [], hours: "", products: [],
            requiredFields: { Name: false, email: false, Type: false, phone: false, currency: false, code: false }, user: "", reps: [], userId: 0, USClients2: [],
            supervisorInput: false, Reps: [], submit: false, loading: true, subareas: [], token: "", save: false, daysSave: [], time: "",
            preventSymbols: ["e", "E", "+", "-", "."], authenticate: false, street: "", street2: "", country: "", city: "", zip: "",
            state: "", jobposition: "", websitelink: "", group: "", title: "", category: "", adresstype: "", currency: "", tax: "", code: "", errors: {}, alertUndefined: false
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });
        const token = localStorage.getItem("Token");
        const count = localStorage.getItem("UnsyncedClientsCount");
        const clients = localStorage.getItem("UnsyncedClients");
        await this.setState({ token: JSON.parse(token), createCount: JSON.parse(count), USClients2: JSON.parse(clients) });

        const getCountries = constantURI() + "GetCountries?token=" + this.state.token;
        const getTitles = constantURI() + "GetTitles?token=" + this.state.token;
        const getStates = constantURI() + "GetStates?token=" + this.state.token;
        const getPartnerType = constantURI() + "GetPartnerType?token=" + this.state.token;
        const getPartnerCategory = constantURI() + "GetPartnerCategory?token=" + this.state.token;
        const getPartnerGroup = constantURI() + "GetPartnerGroup?token=" + this.state.token;
        const getCurrencies = constantURI() + "GetCurrencies?token=" + this.state.token;

        if (this.state.authenticate) {
            await _post(getStates).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ countries: data.result })
                        localStorage.setItem('Countries', JSON.stringify(this.state.countries));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getPartnerType).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ typeT: data.result })
                        localStorage.setItem('Type', JSON.stringify(this.state.typeT));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getTitles).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ titleT: data.result })
                        localStorage.setItem('Title', JSON.stringify(this.state.titleT));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getPartnerCategory).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ potential: data.result })
                        localStorage.setItem('Potential', JSON.stringify(this.state.potential));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getCountries).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ specialties: data.result })
                        localStorage.setItem('Specialties', JSON.stringify(this.state.specialties));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getPartnerGroup).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ groupT: data.result })
                        localStorage.setItem('Group', JSON.stringify(this.state.groupT));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(getCurrencies).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ currencyT: data.result, loading: false })
                        localStorage.setItem('Currency', JSON.stringify(this.state.currencyT));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })

        }
        else {
            const countr = localStorage.getItem('Countries');
            const type = localStorage.getItem('Type');
            const title = localStorage.getItem('Title');
            const potent = localStorage.getItem('Potential');
            const speci = localStorage.getItem('Specialties');
            const grp = localStorage.getItem('Group');
            const curr = localStorage.getItem('Currency');
            this.setState({
                countries: JSON.parse(countr), typeT: JSON.parse(type), loading: false, titleT: JSON.parse(title), potential: JSON.parse(potent),
                specialties: JSON.parse(speci), groupT: JSON.parse(grp), currencyT: JSON.parse(curr)
            });
        }

    }

    validateEmail = (email) => {
        if (this.state.email !== "") {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        } else if (this.state.email === 0) {
            return null;
        }
    };

    onChangeSelectedRep = async (e) => {
        this.state.reps.forEach((item) => {
            if (item.name === e.target.value)
                this.setState({ userId: item.id });
        })
    }

    onChangeName = (e) => {
        this.setState({ name: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Name = false })
        else
            this.setState({ ...this.state.requiredFields.Name = true })
    }

    onChangeAvailability = (e) => {
        this.setState({ availability: e.target.value })
    }

    onChangeStreet = (e) => {
        this.setState({ street: e.target.value })
    }

    onChangeStreet2 = (e) => {
        this.setState({ street2: e.target.value })
    }

    onChangeCode = (e) => {
        this.setState({ code: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.code = false })
        else
            this.setState({ ...this.state.requiredFields.code = true })
    }

    onChangeCountry = (e) => {
        this.setState({ country: e.target.value })
    }

    onChangeCity = (e) => {
        this.setState({ city: e.target.value })
    }

    onChangeState = (e) => {
        this.setState({ state: e.target.value })
    }

    onChangeZip = (e) => {
        this.setState({ zip: e.target.value })
    }

    onChangeCurrency = (e) => {

        this.setState({ currency: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.currency = false })
        else
            this.setState({ ...this.state.requiredFields.currency = true })
    }

    onChangeJobPosition = (e) => {
        this.setState({ jobposition: e.target.value })
    }

    onChangeWebsiteLink = (e) => {
        this.setState({ websitelink: e.target.value })

    }

    onChangeTitle = (e) => {
        this.setState({ title: e.target.value })
    }

    onChangeGroup = (e) => {
        this.setState({ group: e.target.value })

    }

    onChangeCategory = (e) => {
        this.setState({ category: e.target.value })
    }

    onChangeAdressType = (e) => {
        this.setState({ adresstype: e.target.value })

    }

    onChangeTax = (e) => {
        this.setState({ tax: e.target.value })

    }

    onChangeType = (e) => {
        this.setState({ type: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Type = false })
        else
            this.setState({ ...this.state.requiredFields.Type = true })
    }

    onChangeCPC = (e) => {
        this.setState({ CPC: e.target.value })
    }

    onChangeCF = (e) => {
        this.setState({ CF: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.CF = false })
        else
            this.setState({ ...this.state.requiredFields.CF = true })
    }

    onChangeBrick = (e) => {
        this.setState({ brick: e.target.value })
    }

    onChangeArea = async (e) => {
        await this.setState({ area: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Area = false })
        else
            this.setState({ ...this.state.requiredFields.Area = true })

        const tempSubarea = [];
        await this.state.allSubareas.forEach((item) => {
            if (item.x_country_state_id[0] === Number(this.state.area)) {
                tempSubarea.push(item);
            }
        })
        await this.setState({ subareas: tempSubarea });
    }

    onChangeSubarea = (e) => {
        this.setState({ subarea: e.target.value })
    }

    onChangeAddress = (e) => {
        this.setState({ address: e.target.value })
    }

    onChangePhone = (e) => {
        this.setState({ phone: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.phone = false })
        else
            this.setState({ ...this.state.requiredFields.phone = true })
    }

    onChangeMobile = (e) => {
        this.setState({ mobile: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.Mobile = false })
        else
            this.setState({ ...this.state.requiredFields.Mobile = true })
    }

    onChangeEmail = (e) => {
        this.setState({ email: e.target.value });

    }

    onChangeBirthday = (date) => {
        this.setState({ birthday: date });
    }

    onChangeItems = (e) => {
        var itemsSelected = e.target.options;
        var values = [];
        for (var i = 0, l = itemsSelected.length; i < l; i++) {
            if (itemsSelected[i].selected) {
                values.push(itemsSelected[i].value);
            }
        }
        this.setState({ items: values });
    }

    onChangeDeal = (e) => {
        this.setState({ deal: e.target.value })
    }

    onChangeDays = (e) => {
        var itemsSelected = e.target.options;
        var values = [];
        for (var i = 0, l = itemsSelected.length; i < l; i++) {
            if (itemsSelected[i].selected) {
                values.push(Number(itemsSelected[i].value));
            }
        }
        this.setState({ days: values });
    }

    onChangeHours = (e) => {
        this.setState({ hours: e.target.value })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        alert(`name: ${this.state.name}`)
    }

    onSync = async () => {
        await this.setState({ disableSync: true });
        const clients = localStorage.getItem('UnsyncedClients');
        await this.setState({ USClients2: JSON.parse(clients) });
        await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });

        this.state.USClients2.map(async (client, index, arr) => {
            if (this.state.authenticate) {
                await _post(client).then((response) => {
                    return response.json().then(async (data) => {
                        await localStorage.setItem('UnsyncedClientsCount', JSON.stringify(0));
                        await localStorage.setItem('UnsyncedClients', JSON.stringify([]));
                        await localStorage.setItem('UnsyncedClientItems', JSON.stringify([]));
                        await localStorage.setItem('UUIDClients', JSON.stringify([]));
                        if (index === arr.length - 1) {
                            await alert("Synced Successfully");
                            this.props.history.push("./Client");
                        }
                    })
                })
            }
            else {
                alert("Only sync when connected to the Internet!");
                await this.setState({ disableSync: false });
            }
        })

    }

    onSave = async (values) => {
        var clients = (this.state.USClients2 === null || this.state.USClients2 === []) ? [] : this.state.USClients2;
        this.setState({ save: true, showalert: true })
        const isEmail = this.validateEmail(this.state.email);
        this.setState({ ...this.state.submit = true })
        if (!values.Name) {
            this.setState({ alertdanger: "Name is required" })
        } else if (!values.Type) {
            this.setState({ alertdanger: "Type is required" })
        } else if (!values.phone) {
            this.setState({ alertdanger: "phone is required" })
        } else if (!values.currency) {
            this.setState({ alertdanger: "currency is required" })
        } else if (!values.code) {
            this.setState({ alertdanger: "code is required" })
        }
        else if (!isEmail) {
            this.setState({ alertdanger: "invalid Email" })
        }
        else {
            this.setState({ alertdanger: "Work Successful" });
            await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });

            const createClient = constantURI() + "CreateClient?token=" + this.state.token + "&name=" + this.state.name + "&partnerType=" +
                Number(this.state.type) + "&street" + this.state.street + "&secondStreet=" + this.state.street2 + "&city=" + this.state.city + "&state=" +
                Number(this.state.state) + "&zip" + this.state.zip + "&country=" + Number(this.state.country) + "&group=" + Number(this.state.group) +
                "&title=" + this.state.title + "&currency=" + Number(this.state.currency) + "&reference=" + this.state.code + "&function=" + this.state.jobposition +
                "&type=" + "" + "&phone=" + this.state.phone + "&vat=" + this.state.tax + "&mobile=" + this.state.mobile + "&email=" + this.state.email +
                "&category=" + Number(this.state.category) + "&website=" + this.state.websitelink + "&clientType=" + 1 + "&rank=" + 1 + "&comment=" +
                "[{\"default_code\":\"CYLFILGAX0021M\",\"stock\":0,\"returnValue\":0,\"productId\":27},{\"default_code\":\"CYLFILGAX0022M\",\"stock\":0,\"returnValue\":0,\"productId\":29},{\"default_code\":\"CYLFILGAX0023M\",\"stock\":0,\"returnValue\":0,\"productId\":31},{\"default_code\":\"CYLFILGAX0024M\",\"stock\":0,\"returnValue\":0,\"productId\":33},{\"default_code\":\"CYLFILGAX0026M\",\"stock\":0,\"returnValue\":0,\"productId\":35},{\"default_code\":\"CYLFILGAX0051M\",\"stock\":0,\"returnValue\":0,\"productId\":37},{\"default_code\":\"CYLFILGAX0052M\",\"stock\":0,\"returnValue\":0,\"productId\":39},{\"default_code\":\"CYLFILGAX0053M\",\"stock\":0,\"returnValue\":0,\"productId\":41},{\"default_code\":\"CYLFILGAX0054M\",\"stock\":0,\"returnValue\":0,\"productId\":43},{\"default_code\":\"CYLFILGAX0056M\",\"stock\":0,\"returnValue\":0,\"productId\":45},{\"default_code\":\"CYLFILGAX0057.5M\",\"stock\":0,\"returnValue\":0,\"productId\":47},{\"default_code\":\"CYLFILGAX0057M\",\"stock\":0,\"returnValue\":0,\"productId\":49},{\"default_code\":\"CYLFILGAX0059M\",\"stock\":0,\"returnValue\":0,\"productId\":51}]";

            if (this.state.authenticate) {
                await _post(createClient).then(() => {
                    this.props.history.push("/Client");
                })
            }
            else {
                await clients.push(createClient);
                this.setState({ createCount: this.state.createCount + 1 });
                await localStorage.setItem('UnsyncedClientsCount', JSON.stringify(this.state.createCount));
                await localStorage.setItem('UnsyncedClients', JSON.stringify(clients));
                await alert("This Client is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                this.props.history.push("./Client");
            }
        }
        this.setState({ save: false });
    }

    render() {
        if (!this.state.loading) {
            return (
                <form >
                    <div className="container-fluid" style={stylesASAP.mainBackgroundColor}>
                        {(!this.state.alertUndefined) ?
                            null :
                            <div className="col alert alert-danger">
                                <div className="row">
                                    <h6 className="col-sm-8">There seems to be a problem.</h6>
                                    <div className="col d-flex flex-row-reverse">
                                        <div className="btn" style={stylesMed.wideButton} onClick={() => window.location.reload()}>Reload</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(this.state.createCount === 0 || this.state.createCount === null) ?
                            <div className="alert alert-secondary">You have 0 changes to sync with Odoo.</div> :
                            <div className="col alert alert-danger">You have {this.state.createCount} changes to sync with Odoo.
                                <div className="row">
                                    <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                                    <div className="col-sm-4 d-flex flex-row-reverse">
                                        <div className="btn" style={stylesASAP.wideButton} onClick={this.onSync}>Sync Changes</div>
                                    </div>
                                </div>
                            </div>
                        }

                        {(this.state.showalert) ?
                            <div className={(this.state.alertdanger === "Work Successful") ? "alert alert-success" : "alert alert-danger"} >{this.state.alertdanger}</div>
                            : null} <div className="row pt-3">
                            <div className="col">
                                <ArrowBackCircle className="btn" onClick={() => this.props.history.push("/Client")} color={'#00bfff'} height="50px" width="50px" />
                            </div>
                            <div className="col"><h5 style={stylesASAP.visitTitle}>Create Client</h5></div>
                            <div className="col d-flex flex-row-reverse">
                                <div className={(this.state.save) ? "btn disabled" : "btn"} style={stylesASAP.wideButton} onClick={() => this.onSave(this.state.requiredFields)} type="submit" >Save</div>
                            </div>
                        </div>
                        <div className="mt-4 p-3 mb-4" style={stylesASAP.cardBackgroundColor}>
                            <div className="row">
                                <div className="col">
                                    <label><h6>Name* </h6></label>
                                    <FaUser style={stylesASAP.fa} />
                                    <input className="col form-control" placeholder="Please Enter your Name" value={this.state.name} onChange={this.onChangeName}
                                        style={(this.state.submit && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group">
                                    <label><h6>Type*</h6></label>

                                    <select className="col-sm-6 form-control" id="sel1" value={this.state.type} onChange={this.onChangeType}
                                        name="sellist1" style={(this.state.submit && !this.state.requiredFields.Type) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} >
                                        <option >Choose Your Type</option>

                                        {this.state.typeT.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col">
                                    <label><h6>Phone</h6></label>
                                    <FaPhoneAlt style={stylesASAP.fa} />
                                    <input className="col form-control" value={this.state.phone} onChange={this.onChangePhone} placeholder="Please Enter your PhoneNumber" type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        style={(this.state.submit && !this.state.requiredFields.phone) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group">
                                    <label><h6>Mobile</h6></label>
                                    <FaMobileAlt style={stylesASAP.fa} />
                                    <input className="col form-control" placeholder="Please Enter your MobileNumber" value={this.state.mobile} onChange={this.onChangeMobile} type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col">
                                    <label><h6>Email</h6></label>
                                    <MdEmail style={stylesASAP.fa} />
                                    <input className="col form-control" placeholder="Please Enter your Email" value={this.state.email} onChange={this.onChangeEmail}
                                        style={(this.state.submit && !this.validateEmail(this.state.email)) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group invisible">
                                    <label><h6>Birthday</h6></label>
                                    <FaBirthdayCake style={stylesASAP.fa} />
                                    <DatePicker style={stylesASAP.reportClientInput} className="col form-control" selected={this.state.birthday} onChange={(date) => this.onChangeBirthday(date)} />
                                </div>
                            </div>
                            <br />
                            <hr />
                            <hr />
                            <div className="row">
                                <label><h6>Company Adress :</h6></label>
                                <div className="col form-group">
                                    <input className="col form-control" placeholder="Street..." value={this.state.street} onChange={this.onChangeStreet}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group ">
                                    <select className="col form-control" id="sel1" value={this.state.country} onChange={this.onChangeCountry}
                                        name="sellist1" style={stylesASAP.reportClientInput}>
                                        <option> Choose Your Country</option>
                                        {this.state.specialties.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="col form-group">
                                    <input className="col form-control" placeholder="City..." value={this.state.city} onChange={this.onChangeCity}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col form-group">
                                    <input className="col form-control" placeholder="Street 2..." value={this.state.street2} onChange={this.onChangeStreet2}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group ">
                                    <select className="col form-control" id="sel1" value={this.state.state} onChange={this.onChangeState}
                                        name="sellist1" style={stylesASAP.reportClientInput}>
                                        <option >Choose Your State</option>

                                        {this.state.countries.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="col form-group">
                                    <input className="col form-control" placeholder="Zip Code" value={this.state.zip} onChange={this.onChangeZip} type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                            </div>
                            <hr />
                            <hr />
                        </div>

                        <div className="mt-4 p-3" style={stylesASAP.cardBackgroundColor}>
                            <div className="row">
                                <div className="col form-group">
                                    <label><h6>Currency*</h6></label>
                                    <select className="col-sm-6 form-control" id="sel1" value={this.state.currency} onChange={this.onChangeCurrency}
                                        name="sellist1" style={(this.state.submit && !this.state.requiredFields.currency) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} >
                                        <option >Choose Your Currency</option>
                                        {this.state.currencyT.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="col form-group">
                                    <label><h6>TaxId</h6></label>
                                    <input className="col form-control" placeholder="Taxes" value={this.state.tax} onChange={this.onChangeTax} type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                {/*<div className="col form-group">*/}
                                {/*    <label>Preferred Visit Time:</label><br></br>*/}
                                {/*    <TimePicker className="col" value={this.state.time} onChange={this.onChangeTime}*/}
                                {/*        showSecond={false} allowEmpty />*/}
                                {/*</div>*/}
                            </div>
                            <br />
                            <div className="row">
                                <div className="col form-group">
                                    <label><h6>Group</h6></label>
                                    <select className="col-sm-6 form-control" id="sel1" value={this.state.group} onChange={this.onChangeGroup}
                                        name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput}>
                                        <option >Choose Your Group</option>
                                        {this.state.groupT.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }

                                    </select>
                                </div>
                                <div className="col form-group invisible">
                                    <label><h6>Adress Type</h6></label>
                                    <select className="col-sm-6 form-control" id="sel1" value={this.state.adresstype} onChange={this.onChangeAdressType}
                                        name="sellist1" style={stylesASAP.reportClientInput}>
                                        <option >Choose Your AdressType</option>
                                        <option value="1">Contact</option>
                                        <option value="2">Invoicce Adress</option>
                                        <option value="3">Delivery Adress</option>
                                        <option value="4">Other Adress</option>
                                        <option value="5">Private Adress</option>
                                    </select>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col">
                                    <label><h6>Code*</h6></label>
                                    <input className="col form-control" placeholder="Code Item" value={this.state.code} onChange={this.onChangeCode} type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        style={(this.state.submit && !this.state.requiredFields.code) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col">
                                    <label><h6>Title</h6></label>
                                    <select className="col-sm-6 form-control" id="sel1" value={this.state.title} onChange={this.onChangeTitle}
                                        name="sellist1" style={stylesASAP.reportClientInput}>
                                        <option >Choose Your Title</option>
                                        {this.state.titleT.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col">
                                    <label><h6>Website Link</h6></label>
                                    <input className="col form-control" placeholder="e.g. https://www.xxx.com" value={this.state.websitelink} onChange={this.onChangeWebsiteLink}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group">
                                    <label><h6>Category</h6></label>
                                    <select className="col-sm-6 form-control" id="sel1" value={this.state.category} onChange={this.onChangeCategory}
                                        name="sellist1" style={stylesASAP.reportClientInput}>
                                        <option >Choose Your Category</option>
                                        {this.state.potential.map((item) => {
                                            return (
                                                <option value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col form-group">
                                    <label><h6>Job Position</h6></label>
                                    <input className="col form-control" placeholder="e.g. Sales Director" value={this.state.jobposition} onChange={this.onChangeJobPosition} type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.Name) ?
                                            stylesASAP.reportClientInputRequired : stylesASAP.reportClientInput} />
                                </div>
                                <div className="col form-group invisible" >
                                    <label>Select Representative:</label>
                                    <select className="col-sm-7 form-control" id="sel1" value={this.state.selectedRep}
                                        onChange={this.onChangeSelectedRep} name="sellist1" style={stylesASAP.planInput}>
                                        <option value=""></option>
                                        {this.state.Reps.map((item, index) => {
                                            return (
                                                <option key={index} value={item.name}>{item.name}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            {/*<div className="row">*/}
                            {/*    <div className={(!this.state.supervisorInput) ? "col form-group" : "col form-group invisible"}>*/}
                            {/*        <label>Select Representative:</label>*/}
                            {/*        <select className="col-sm-7 form-control" id="sel1" value={this.state.selectedRep}*/}
                            {/*            onChange={this.onChangeSelectedRep} name="sellist1" style={stylesMed.planInput}>*/}
                            {/*            <option value=""></option>*/}
                            {/*            {this.state.Reps.map((item, index) => {*/}
                            {/*                return (*/}
                            {/*                    <option key={index} value={item.name}>{item.name}</option>*/}
                            {/*                )*/}
                            {/*            })}*/}
                            {/*        </select>*/}
                            {/*    </div>*/}
                            {/*    <div className="col form-group invisible">*/}
                            {/*        <label>Preferred Visit Time:</label><br></br>*/}
                            {/*        <TimePicker className="col" value={this.state.time} onChange={this.onChangeTime}*/}
                            {/*            showSecond={false} allowEmpty />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </form>
            );
        }
        else {
            return (
                <Loading history={this.props.history} page={"./list"} name={"ClientAdd"}></Loading>
            )
        }
    }
}